/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css } from 'aphrodite';
import { filter, isEmpty } from 'lodash';

import { BlendBridge } from 'blb-types/blendBridge';
import { DocumentsCard } from '../DocumentsCard';
import { cardWrapperStyles } from '../SectionCard';
import { renderAdditionalDocuments } from 'blb-persona/common/utils/renderDocuments';

export namespace UploadedDocuments {
  export interface Props {
    documents: BlendBridge.API.Document[];
    headerChildren?: React.ReactNode;
    removeDoc: (id: string) => void;
    uploadedById: string;
  }
}

export const UploadedDocuments: React.FC<UploadedDocuments.Props> = ({ documents, headerChildren, removeDoc }) => {
  if (!documents) {
    return null;
  }

  const closingPackage = filter(documents, { type: 'CLOSING_PACKAGE' });
  const titleDocuments = filter(documents, { type: 'TITLE_DOCUMENT' });
  return (
    <div className={css(cardWrapperStyles.cardGroup)}>
      {!isEmpty(closingPackage) && (
        <div className={css(cardWrapperStyles.singleCardWrapper)}>
          <DocumentsCard
            documents={closingPackage}
            id="it-CompletedClosingPackage"
            isUploaded={true}
            title="Completed Closing Package"
          />
        </div>
      )}

      {!isEmpty(titleDocuments) && (
        <div className={css(cardWrapperStyles.singleCardWrapper)}>
          <DocumentsCard
            documents={titleDocuments}
            headerChildren={headerChildren}
            id="it-TitleDocuments"
            isUploaded={true}
            title="Title Documents"
          />
        </div>
      )}
      {renderAdditionalDocuments(documents, removeDoc)}
    </div>
  );
};
